/** @format */

import { Injectable, NgZone, signal } from '@angular/core';
import idleTimeout from 'idle-timeout';
import { AuthenticationService } from '../auth/authentication.service';

const ALLOWED_IDLE_TIME_MS = 10 * 60 * 1000;

@Injectable({
  providedIn: 'root',
})
export class InactivityService {
  private readonly idleTime = ALLOWED_IDLE_TIME_MS; // 10 minutes
  private instance?: ReturnType<typeof idleTimeout>;

  private timedOutSignal = signal(false);
  timedOut = this.timedOutSignal.asReadonly();

  constructor(
    private readonly ngZone: NgZone,
    private readonly authenticationService: AuthenticationService,
  ) {}

  startWatching(timerMs?: number) {
    console.log('Starting watch...');
    this.initIdleTimeout(timerMs);
  }

  stopWatching() {
    console.log('Stopping watch...');
    this.instance?.destroy();
    this.instance = undefined;
    this.timedOutSignal.set(false);
  }

  restartWatch() {
    this.instance?.reset();
    this.timedOutSignal.set(false);
  }

  private initIdleTimeout(timerMs?: number) {
    this.instance = idleTimeout(
      (element, timeout) => {
        console.log(`Idle state detected after ${timeout} ms`);
        this.timedOutSignal.set(true);
      },
      {
        element: document,
        timeout: timerMs ?? this.idleTime,
        loop: false,
      },
    );
  }

  logout() {
    this.ngZone.run(() => {
      this.authenticationService.logout();
    });
  }
}
